import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { HiOutlinePencilAlt, HiOutlineFilm, HiOutlineGlobeAlt, HiOutlineDocumentText } from 'react-icons/hi';

export default function MarketingDashboard() {
  const [assets, setAssets] = useState([]);
  const [videos, setVideos] = useState([]);
  const [wp, setWp] = useState({ connected: null });
  const [heygen, setHeygen] = useState({ connected: null });

  useEffect(() => {
    api.get('/marketing/assets').then(({ data }) => setAssets(data)).catch(() => {});
    api.get('/marketing/videos').then(({ data }) => setVideos(data)).catch(() => {});
    api.get('/marketing/wordpress/status').then(({ data }) => setWp(data)).catch(() => setWp({ connected: false }));
    api.get('/marketing/heygen/status').then(({ data }) => setHeygen(data)).catch(() => setHeygen({ connected: false }));
  }, []);

  const publishedCount = assets.filter(a => a.wpStatus).length;

  const Stat = ({ icon: Icon, label, value, color }) => (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-2">
        <Icon className={`w-6 h-6 ${color}`} />
        <span className="text-sm font-medium text-gray-500">{label}</span>
      </div>
      <p className="text-3xl font-bold text-gray-900">{value}</p>
    </div>
  );

  const dot = (state) => state === null ? 'bg-gray-300' : state ? 'bg-green-500' : 'bg-red-400';

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Internal Marketing</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <Stat icon={HiOutlineDocumentText} label="Content pieces" value={assets.length} color="text-v2-blue" />
        <Stat icon={HiOutlineGlobeAlt} label="Published to WordPress" value={publishedCount} color="text-green-500" />
        <Stat icon={HiOutlineFilm} label="Videos" value={videos.length} color="text-purple-500" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <Link to="/marketing/studio" className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow flex items-start gap-4">
          <HiOutlinePencilAlt className="w-8 h-8 text-v2-blue flex-shrink-0" />
          <div>
            <div className="font-semibold text-gray-900">Content Studio</div>
            <p className="text-sm text-gray-500 mt-1">Generate blogs, newsletters and pages, then publish to WordPress as drafts.</p>
          </div>
        </Link>
        <Link to="/marketing/videos" className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow flex items-start gap-4">
          <HiOutlineFilm className="w-8 h-8 text-purple-500 flex-shrink-0" />
          <div>
            <div className="font-semibold text-gray-900">AI Videos</div>
            <p className="text-sm text-gray-500 mt-1">Turn a script into a HeyGen avatar video.</p>
          </div>
        </Link>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-sm font-semibold text-gray-700 mb-4">Integrations</h2>
        <div className="space-y-2 text-sm">
          <div className="flex items-center gap-3">
            <span className={`w-2.5 h-2.5 rounded-full ${dot(wp.connected)}`} />
            <span className="text-gray-700">WordPress</span>
            <span className="text-gray-400">{wp.connected === null ? 'checking...' : wp.connected ? wp.url : (wp.error || 'not configured')}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className={`w-2.5 h-2.5 rounded-full ${dot(heygen.connected)}`} />
            <span className="text-gray-700">HeyGen</span>
            <span className="text-gray-400">{heygen.connected === null ? 'checking...' : heygen.connected ? `${heygen.avatarCount} avatars available` : (heygen.error || 'not configured')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
